import { AvatarDecor } from "@/app/shop/content/useFetch";
import { useAuth } from "@/provider/UserProvider";
import { getAvatarDecorByUser } from "@/services/decoration";
import { useEffect, useState } from "react";

export interface UserDecoration {
  userId: number;
  decorationId: number;
  createdAt: string;
  decoration: AvatarDecor;
}

const useDecorByUser = () => {
  const [decor, setDecor] = useState<UserDecoration[]>([]);
  const [userDecorIds, setUserDecorIds] = useState<number[]>([]);
  const { isLoginClient } = useAuth();

  useEffect(() => {
    setUserDecorIds(decor.map(item => item.decorationId))
  }, [decor]);

  const handleGetDecor = async () => {
    try {
      const res = await getAvatarDecorByUser({ size: 30, offset: 0 });
      setDecor(res.data.items || []);
    } catch (error) {
      console.log('get_decor_user: ', error);
    }
  }

  const isBoughtDecor = (id: number) => userDecorIds.includes(id);

  useEffect(() => {
    if (isLoginClient) handleGetDecor();
  }, [isLoginClient]);

  return {
    userDecorIds,
    listDecor: decor,
    isBoughtDecor,
    refresh: handleGetDecor
  }
}

export default useDecorByUser;